import type { IButtonStyles } from '@fluentui/react/lib/Button';

export function getFlexContainerStyle(): IButtonStyles {
    return {
        flexContainer: {
            width: '100%',
            justifyContent: 'flex-start',
        },
    };
}
